<div
  #contentContainerRef
  class="html-editor__content"
  [ngClass]="{
    'html-editor__content--focused': isFocusedSig(),
    'html-editor__content--read-only': isReadOnlySig(),
  }"
>
  <dx-load-panel
    shadingColor="rgba(255, 255, 255, 0.7)"
    [position]="{ of: contentContainerRef }"
    [visible]="isImageUploadingSig()"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    message="Uploading image..."
    [wrapperAttr]="{ class: 'html-editor__image-upload-load-panel' }"
  ></dx-load-panel>

  @if (label) {
    <label
      for="htmlEditor"
      class="html-editor__label dx-widget"
      [ngClass]="{
        'html-editor__label--top': !!value || isFocusedSig(),
        'html-editor__label--focused': isFocusedSig(),
        'html-editor__label--read-only': isReadOnlySig(),
      }"
    >
      {{ label }}
    </label>
  }

  <div class="html-editor__extra-content-container">
    <div *ngIf="useFiledEditing && hasChanges" class="html-editor__controls-container">
      <dx-button
        icon="undo"
        type="danger"
        stylingMode="text"
        hint="REVERT ALL"
        [elementAttr]="{
          class: 'inline-editor-control',
        }"
        [disabled]="inProgress"
        (onClick)="handleRevertClick()"
      ></dx-button>

      <dx-button
        icon="save"
        type="success"
        stylingMode="text"
        hint="SAVE ALL"
        [elementAttr]="{
          class: 'inline-editor-control',
        }"
        template="successButtonTemplate"
        [disabled]="inProgress"
        (onClick)="handleSaveChangesClick()"
      >
        <div *dxTemplate="let item of 'successButtonTemplate'" class="editor-progress-indicator">
          <ng-container *ngIf="inProgress; then loadIndicatorTmp; else saveIconTmp"></ng-container>
        </div>
      </dx-button>
    </div>
  </div>

  <div #editorContainerRef class="html-editor__editor-container" [style.height]="'100%'">
    <div
      #htmlEditorFooter
      class="html-editor__footer"
      [ngClass]="{
        'html-editor__footer--visible': isFocusedSig(),
      }"
    ></div>

    <dx-scroll-view direction="vertical" width="100%" height="100%" class="html-editor__scroll-view">
      <dx-html-editor
        #editorRef
        id="htmlEditor"
        [value]="value"
        [name]="name"
        [allowSoftLineBreak]="true"
        (onValueChanged)="handleValueChange($event)"
        (onFocusIn)="onFocusIn()"
        (onFocusOut)="onFocusOut()"
        class="html-editor__editor"
        [readOnly]="isReadOnlySig()"
        (onInitialized)="onEditorInitialized($event)"
        [customizeModules]="customizeQuillModules"
        [mentions]="mentionsConfigSig()"
      >
        <dxo-toolbar
          *ngIf="!isReadOnlySig()"
          [multiline]="false"
          [items]="toolbarItemsResolvedSig()"
          [container]="htmlEditorFooter"
        >
          <div *dxTemplate="let data of 'clearFormatTmp'">
            <dx-button
              class="html-editor__color-toolbar-item"
              stylingMode="text"
              [icon]="'clearformat'"
              [text]="data.options.text"
              [hint]="data.options.hint"
              (onClick)="clearFormat()"
            ></dx-button>
          </div>

          <div *dxTemplate="let data of 'previewTmp'">
            <dx-button
              class="html-editor__color-toolbar-item"
              stylingMode="text"
              [icon]="'eyeopen'"
              [text]="data.options.text ?? 'Preview'"
              [hint]="data.options.hint ?? 'Preview'"
              (onClick)="onShowPreview.emit(this.value)"
            ></dx-button>
          </div>

          <div *dxTemplate="let data of 'headerTmp'">
            <dx-select-box
              [value]="selectionFormattingSig()[data.name]"
              [stylingMode]="'filled'"
              class="html-editor__color-toolbar-item"
              [items]="data?.acceptedValues"
              [displayExpr]="data?.options?.displayExpr"
              [dropDownOptions]="data?.options?.dropDownOptions"
              (onItemClick)="handleHeaderChange($event)"
            ></dx-select-box>
          </div>

          <div *dxTemplate="let data of 'selectBoxTmp'">
            <dx-select-box
              [acceptCustomValue]="true"
              [value]="selectionFormattingSig()[data.name]"
              [stylingMode]="'filled'"
              class="html-editor__color-toolbar-item"
              [dataSource]="data?.dataSource"
              [displayExpr]="data?.options?.displayExpr"
              [dropDownOptions]="data?.options?.dropDownOptions"
            ></dx-select-box>
          </div>

          <div *dxTemplate="let data of 'customLinkTmp'">
            <dx-popover
              #customLinkPopoverRef
              [target]="$any(customLinkRef?.instance?.$element())"
              [wrapperAttr]="{ class: 'html-editor__color-toolbar-item-popup ag-click-outside--exclusion' }"
              [width]="380"
              [shading]="true"
              [hideOnOutsideClick]="handleOutsidePopoverClick"
              (onHidden)="onLinkPopoverHidden()"
              [toolbarItems]="[
                { location: 'after', toolbar: 'bottom', template: 'cancelButtonTmp' },
                { location: 'after', toolbar: 'bottom', template: 'applyButtonTmp' },
              ]"
            >
              <div *dxTemplate="let data of 'cancelButtonTmp'">
                <dx-button
                  text="Cancel"
                  (onClick)="cancelLinkChanges($event, customLinkPopoverRef)"
                  [width]="80"
                ></dx-button>
              </div>

              <div *dxTemplate="let data of 'applyButtonTmp'">
                <dx-button
                  text="SAVE"
                  [type]="'default'"
                  (onClick)="addLink(customLinkPopoverRef)"
                  [width]="80"
                ></dx-button>
              </div>

              <div *dxTemplate="let popoverData of 'content'" (click)="$event.stopPropagation()">
                <div class="html-editor__variables-root">
                  <dx-form
                    labelMode="floating"
                    [formData]="linkFormDataSig()"
                    [validationGroup]="linkFormValidationGroup"
                  >
                    <dxi-item itemType="group" caption="Action">
                      <dxi-item
                        [dataField]="'type'"
                        [label]="{ text: 'Action Type' }"
                        editorType="dxSelectBox"
                        [editorOptions]="{
                          items: BUTTON_ACTION_TYPE_LOOKUP,
                          valueExpr: LookupKeys.value,
                          displayExpr: LookupKeys.description,
                          searchEnabled: true,
                          placeholder: '',
                          onItemClick: onSelectBoxItemClick,
                          onValueChanged: onLinkTypeValueChanged,
                          dropDownOptions: {
                            minHeight: 'min-content',
                            maxHeight: 165,
                            wrapperAttr: { class: 'ag-click-outside--exclusion' },
                          },
                        }"
                      ></dxi-item>

                      @if (linkFormDataSig()?.type === ButtonActionType.link) {
                        <dxi-item
                          [visible]="!useWebNavigationOnly"
                          [dataField]="'navigateTo'"
                          [label]="{ text: 'Navigate to' }"
                          editorType="dxSelectBox"
                          [editorOptions]="{
                            items: BUTTON_NAVIGATE_TO_LOOKUP,
                            valueExpr: LookupKeys.value,
                            displayExpr: LookupKeys.description,
                            searchEnabled: true,
                            placeholder: '',
                            onItemClick: onSelectBoxItemClick,
                            dropDownOptions: {
                              minHeight: 'min-content',
                              maxHeight: 165,
                              wrapperAttr: { class: 'ag-click-outside--exclusion' },
                            },
                          }"
                        ></dxi-item>

                        <dxi-item
                          [visible]="!useWebNavigationOnly && linkFormDataSig()?.navigateTo === ButtonNavigateTo.portal"
                          [dataField]="'portalPage'"
                          [label]="{ text: 'Portal Page' }"
                          [isRequired]="true"
                          editorType="dxSelectBox"
                          [editorOptions]="{
                            dataSource: portalPagesSig(),
                            searchEnabled: true,
                            placeholder: '',
                            valueExpr: 'link',
                            displayExpr: 'label',
                            onItemClick: onSelectBoxItemClick,
                            grouped: true,
                            dropDownOptions: {
                              container: 'body',
                              zIndex: 2500,
                              minHeight: 'min-content',
                              maxHeight: 165,
                              wrapperAttr: { class: 'html-editor__portal-page-wrapper  ag-click-outside--exclusion' },
                            },
                          }"
                        ></dxi-item>

                        <dxi-item [visible]="useWebNavigationOnly || linkFormDataSig()?.navigateTo === ButtonNavigateTo.web">
                          <div *dxTemplate>
                            <ng-content
                              *ngTemplateOutlet="
                                textBoxWithVarsTmp;
                                context: {
                                  label: 'URL',
                                  isRequired: true,
                                  items: variablesSig() | htmlEditorVariablesSelectBoxItems: HtmlEditorVariableType.url,
                                  validationRules: [
                                    {
                                      type: 'required',
                                      message: Messages.REQUIRED_URL_TEXT,
                                    },
                                    {
                                      type: 'custom',
                                      validationCallback: validateUrlWithoutProtocol,
                                      message: Messages.INVALID_URL_FORMAT_TEXT,
                                    },
                                  ],
                                }
                              "
                            ></ng-content>
                          </div>
                        </dxi-item>

                        <dxi-item
                          [dataField]="'target'"
                          [label]="{ text: 'Open in' }"
                          editorType="dxRadioGroup"
                          [cssClass]="'ag-radio-group'"
                          [editorOptions]="{
                            items: HREF_TARGET_LOOKUP,
                            valueExpr: LookupKeys.value,
                            displayExpr: LookupKeys.description,
                            layout: 'horizontal',
                          }"
                        ></dxi-item>
                      }

                      @if (linkFormDataSig()?.type === ButtonActionType.mailTo) {
                        <dxi-item>
                          <div *dxTemplate>
                            <ng-content
                              *ngTemplateOutlet="
                                textBoxWithVarsTmp;
                                context: {
                                  label: 'To',
                                  items: variablesSig() | htmlEditorVariablesSelectBoxItems: HtmlEditorVariableType.email,
                                  validationRules: [{ type: 'email' }],
                                }
                              "
                            ></ng-content>
                          </div>
                        </dxi-item>

                        <dxi-item [dataField]="'subject'" [label]="{ text: 'Subject' }"></dxi-item>

                        <dxi-item [dataField]="'body'" [label]="{ text: 'Body' }"></dxi-item>
                      }
                      <dxi-item [visible]="linkFormDataSig()?.type === ButtonActionType.phone">
                        <div *dxTemplate>
                          <ng-content
                            *ngTemplateOutlet="
                              textBoxWithVarsTmp;
                              context: {
                                label: 'Number',
                                mask: phoneMask,
                                items: variablesSig() | htmlEditorVariablesSelectBoxItems: HtmlEditorVariableType.phone,
                                validationRules: [
                                  {
                                    type: 'pattern',
                                    pattern: phonePattern,
                                    message: Messages.INVALID_PHONE_DIGITS_TEXT,
                                  },
                                ],
                              }
                            "
                          >
                          </ng-content>
                        </div>
                      </dxi-item>
                    </dxi-item>

                    <dxi-item itemType="group" caption="Link Styling">
                      <dxi-item [dataField]="'linkColor'" [label]="{ text: 'Font Color' }">
                        <div *dxTemplate>
                          <ag-shr-color-sketch-input
                            [(value)]="linkFormDataSig().linkColor"
                            [label]="'Font Color'"
                            [presetColors]="linkStylePresetColorsSig()"
                          ></ag-shr-color-sketch-input>
                        </div>
                      </dxi-item>

                      <dxi-item
                        [dataField]="'linkUnderline'"
                        [label]="{ text: 'Underline' }"
                        editorType="dxSelectBox"
                        [editorOptions]="{
                          items: linkUnderlineOptions,
                          valueExpr: 'value',
                          displayExpr: 'description',
                          onItemClick: onSelectBoxItemClick,
                          dropDownOptions: {
                            minHeight: 'min-content',
                            wrapperAttr: { class: 'ag-click-outside--exclusion' },
                          },
                        }"
                      ></dxi-item>
                    </dxi-item>

                    <dxi-item
                      itemType="group"
                      caption="Mouseover Styling"
                      [captionTemplate]="useWebNavigationOnly ? 'mouseoverStylingCaptionTmp' : null"
                    >
                      <dxi-item [dataField]="'mouseoverColor'" [label]="{ text: 'Font Color' }">
                        <div *dxTemplate>
                          <ag-shr-color-sketch-input
                            [(value)]="linkFormDataSig().mouseoverColor"
                            [label]="'Font Color'"
                            [presetColors]="linkStylePresetColorsSig()"
                          ></ag-shr-color-sketch-input>
                        </div>
                      </dxi-item>

                      <dxi-item
                        [dataField]="'mouseoverUnderline'"
                        [label]="{ text: 'Underline' }"
                        editorType="dxSelectBox"
                        [editorOptions]="{
                          items: linkUnderlineOptions,
                          valueExpr: 'value',
                          displayExpr: 'description',
                          onItemClick: onSelectBoxItemClick,
                          dropDownOptions: {
                            minHeight: 'min-content',
                            wrapperAttr: { class: 'ag-click-outside--exclusion' },
                          },
                        }"
                      ></dxi-item>
                    </dxi-item>

                    @if (useWebNavigationOnly) {
                      <div
                        *dxTemplate="let data of 'mouseoverStylingCaptionTmp'"
                        class="html-editor__form-group-caption"
                      >
                        <span>{{ data.caption }}</span>
                        <i #mouseoverStylingInfoIconRef class="dx-icon dx-icon-info html-editor__group-info-icon">
                          <dx-tooltip
                            [target]="mouseoverStylingInfoIconRef"
                            showEvent="mouseenter"
                            hideEvent="mouseleave"
                            [position]="'top'"
                            [maxWidth]="300"
                          >
                            <div class="text-wrap text-start" *dxTemplate="let tooltipData of 'content'">
                              {{ mouseoverStylingEmailHint }}
                            </div>
                          </dx-tooltip>
                        </i>
                      </div>
                    }
                  </dx-form>
                </div>
              </div>
            </dx-popover>

            <dx-button
              #customLinkRef
              class="html-editor__color-toolbar-item"
              [class.dx-state-selected]="!!selectionFormattingSig()[data.name]"
              stylingMode="text"
              [icon]="'link'"
              [disabled]="!(quillActiveElement?.tagName == 'A' || !!quillRange?.length)"
              [text]="data.options.text"
              [hint]="data.options.hint"
              (onClick)="manageLink($event, customLinkPopoverRef)"
            ></dx-button>
          </div>

          <div *dxTemplate="let data of 'variableTmp'">
            <dx-button
              #variablePickerRef
              class="html-editor__color-toolbar-item"
              stylingMode="text"
              [icon]="'variable'"
              [text]="data.options.text"
              [hint]="data.options.hint"
              (onClick)="handleVariableButtonClick($event)"
            >
            </dx-button>
          </div>

          <div *dxTemplate="let data of 'imageUploadTmp'">
            <dx-button
              class="html-editor__color-toolbar-item"
              stylingMode="text"
              [icon]="'image'"
              [text]="data.options?.text"
              [hint]="data.options?.hint ?? 'Upload Media'"
              (onClick)="onImageToolbarClick()"
            ></dx-button>
          </div>

          <div *dxTemplate="let data of 'colorPickerTmp'">
            <div (click)="$event.stopPropagation()">
              <dx-button
                #colorPickerRef
                class="html-editor__color-toolbar-item"
                [class.html-editor__color-toolbar-item--transparent]="
                  selectionFormattingSig()?.[data.name] === 'transparent'
                "
                [style.--selected-color]="selectionFormattingSig()?.[data.name]"
                stylingMode="text"
                [icon]="data.name"
                [text]="data.options.text"
                [hint]="data.options.hint"
                (onClick)="$event.event.stopPropagation()"
              ></dx-button>

              <ag-shr-color-sketch-popover
                [target]="$any(colorPickerRef?.instance?.$element())"
                [value]="selectionFormattingSig()?.[data.name]"
                (valueChange)="applyColorChanges(data?.name)"
                (onApplyColor)="applyColor($event, data.name)"
                (onCancelColorChanges)="cancelColorChanges(data.name)"
                [presetColors]="presetColors"
                (onShowing)="onToolbarItemShowing($event, data.name, selectionFormattingSig()[data.name])"
                [handleOutsidePopoverClick]="handleOutsidePopoverClick"
              >
              </ag-shr-color-sketch-popover>
            </div>
          </div>
          <div *dxTemplate="let data of 'lineHeightTmp'">
            <div (click)="$event.stopPropagation()">
              @if (!!quill) {
                <dx-drop-down-button
                  [stylingMode]="'text'"
                  icon="indent"
                  [useSelectMode]="true"
                  [useItemTextAsTitle]="true"
                  [selectedItemKey]="selectionFormattingSig()?.lineHeight"
                  [items]="TemplateLineHeightLookup"
                  class="html-editor__line-height-control"
                  [dropDownOptions]="{ wrapperAttr: { class: 'ag-click-outside--exclusion' } }"
                  (onSelectionChanged)="onSelectionChanged($event)"
                  [showArrowIcon]="false"
                  [keyExpr]="'value'"
                  [displayExpr]="'description'"
                ></dx-drop-down-button>
              }
            </div>
          </div>
        </dxo-toolbar>

        <dx-validator [validationGroup]="validationGroup">
          <dxi-validation-rule *ngIf="isRequired" type="required" [message]="label + ' ' + Messages.REQUIRED_TEXT">
          </dxi-validation-rule>
        </dx-validator>

        <dxo-media-resizing [enabled]="true"></dxo-media-resizing>
      </dx-html-editor>
    </dx-scroll-view>
  </div>
</div>

<ag-shr-media-uploader-modal
  [mediaPathPrefix]="fileDirectory"
  [mediaSources]="mediaSources"
  [mediaItems]="mediaItems"
  [maxFileSizeMb]="maxFileSizeMb"
  [applyImageDownscale]="applyImageDownscale"
  [waitForProcessing]="true"
  [placeholder]="'Click or Drag an Image (max ' + maxFileSizeLabel + ')'"
  (mediaChanged)="onMediaChanged($event)"
></ag-shr-media-uploader-modal>

<ng-template #saveIconTmp>
  <i class="dx-icon dx-icon-save"></i>
</ng-template>

<ng-template #loadIndicatorTmp>
  <dx-load-indicator
    class="editor-progress-indicator__indicator"
    [visible]="true"
    height="18"
    width="18"
  ></dx-load-indicator>
</ng-template>

<ng-template
  #textBoxWithVarsTmp
  let-label="label"
  let-mask="mask"
  let-items="items"
  let-validationRules="validationRules"
  let-isRequired="isRequired"
>
  <div #inputContainerRef>
    <dx-select-box
      #varSelectBoxRef
      [acceptCustomValue]="true"
      [(value)]="linkFormDataSig().value"
      [label]="label"
      [valueExpr]="'value'"
      [displayExpr]="'description'"
      [labelMode]="mask ? 'static' : 'floating'"
      [placeholder]="''"
      (onCustomItemCreating)="handleCustomItemCreating($event)"
      [items]="items"
      [grouped]="true"
      (onItemClick)="onSelectBoxItemClick($event)"
      [openOnFieldClick]="false"
      [showDropDownButton]="!!items?.length"
      [showClearButton]="true"
      [dropDownOptions]="{ wrapperAttr: { class: 'ag-click-outside--exclusion' } }"
      fieldTemplate="field"
      [validationMessagePosition]="'top'"
      [ngClass]="{ 'ag-required-field': isRequired ?? false }"
    >
      <dx-validator [validationGroup]="linkFormValidationGroup">
        <dxi-validation-rule type="required"></dxi-validation-rule>

        @if (!varSelectBoxRef?.selectedItem || varSelectBoxRef?.selectedItem?.isCustom) {
          @for (validationRule of validationRules; track $index) {
            @switch (validationRule.type) {
              @case ("custom") {
                <dxi-validation-rule
                  [type]="validationRule.type"
                  [validationCallback]="validationRule.validationCallback"
                  [message]="validationRule.message"
                ></dxi-validation-rule>
              }
              @default {
                <dxi-validation-rule
                  [type]="validationRule.type"
                  [pattern]="validationRule.pattern"
                  [message]="validationRule.message"
                ></dxi-validation-rule>
              }
            }
          }
        }
      </dx-validator>

      <div *dxTemplate="let data of 'field'">
        <dx-text-box
          [value]="data?.description ?? linkFormDataSig().value"
          (valueChange)="linkFormDataSig().value = $event"
          [showClearButton]="false"
          [readOnly]="data && !data?.isCustom"
          [mask]="!data || data?.isCustom ? mask : undefined"
          [useMaskedValue]="false"
        >
        </dx-text-box>
      </div>

      <div *dxTemplate="let data of 'dropDownButton'">
        <i class="dx-icon-variable"></i>
      </div>

      <div *dxTemplate="let item of 'group'">
        <div>{{ item.collectionDescription }}</div>
      </div>
    </dx-select-box>
  </div>
</ng-template>
